<template>
       <Frame>
        <PageHeader :title="$t('comm.qmAbnQlyOrder')" :hasBack="false" />
        <div class="qmAbnQlyOrder_contain">
            <div class="filter_row">
                <div class="filter_col">
                    <span>{{ $t('Deliver.prodId') }}：</span>
                    <el-input v-model="MaterialId" :placeholder="$t('Deliver.inputpls')"
                        @change="inputchange()" size="small" clearable></el-input>
                </div>
                <div class="filter_col" style="min-width: 285px;">
                    <span>{{ $t('QmAbnQlyOrder.discoverdate') }}：</span>
                    <el-date-picker v-model="myDate" type="daterange" size="small" range-separator="~" class="datepicker"
                        :start-placeholder="$t('comm.startdate')" :end-placeholder="$t('comm.enddate')"
                        :unlink-panels="true" @change="gettime()" >
                    </el-date-picker>
                </div>
                <div class="filter_col">
                    <span>{{ $t('QmAbnQlyOrder.materialName') }}：</span>
                    <el-input v-model="MaterialName" :placeholder="$t('Deliver.inputpls')"
                        @change="inputchange()" size="small" clearable></el-input>
                </div>
                <div v-if="$store.state.ShowBatchNo" class="filter_col">
                    <span>{{ $t('QmAbnQlyOrder.batchNo') }}：</span>
                    <el-input v-model="batchNo" :placeholder="$t('Deliver.inputpls')"
                        @change="inputchange()" size="small" clearable></el-input>
                </div> 
            </div>
            <div class="filter_row" style="padding-top: 0;">
                <div class="filter_col" v-if="$store.state.ShowMTO">
                    <span>{{ $t('Deliver.mtoNo') }}：</span>
                    <el-input v-model="mtoNo" :placeholder="$t('Deliver.inputpls')"
                        @change="inputchange()" size="small" clearable></el-input>
                </div>
                <div class="checkgroup filter_col" style="min-width: 280px;">
                    <span class="checkgroup-label">{{ $t('QmAbnQlyOrder.HiddenDangerLevel') }}：</span>
                    <span>
                        <el-checkbox @change="getorderdata(0);" v-model="Deadly" :disabled="isDisabled" :label="$t('QmAbnQlyOrder.ADeadly')"></el-checkbox>
                        <el-checkbox @change="getorderdata(0);" v-model="Seriousness" :disabled="isDisabled" :label="$t('QmAbnQlyOrder.BSeriousness')"></el-checkbox>
                        <el-checkbox @change="getorderdata(0);" v-model="Slight" :disabled="isDisabled" :label="$t('QmAbnQlyOrder.CSlight')"></el-checkbox>
                    </span>
                </div>
                <div class="checkgroup filter_col" style="min-width: 300px;">
                    <span class="checkgroup-label">{{ $t('QmAbnQlyOrder.treatmentstate') }}：</span>
                    <span>
                        <el-checkbox @change="getorderdata(0);" v-model="TobeConfirmed" :disabled="isDisabled" :label="$t('QmAbnQlyOrder.TobeConfirmed')"></el-checkbox>
                        <el-checkbox @change="getorderdata(0);" v-model="Processing" :disabled="isDisabled" :label="$t('QmAbnQlyOrder.Processing')"></el-checkbox>
                        <el-checkbox @change="getorderdata(0);" v-model="finished" :disabled="isDisabled" :label="$t('QmAbnQlyOrder.finished')"></el-checkbox>
                    </span>
                </div>
                <div class="filter_col buttongroup" >
                    <el-button type="reset" @click="reset()">{{ $t('button.reset') }}</el-button>
                    <el-button type="primary" @click="query()">{{ $t('button.query') }}</el-button>
                </div>
            </div>
            <el-table ref="multipleTable" :data="tableData" :height="tableHeight" style="margin:0;width:100%" v-loading="tableLoading">
                <el-table-column key="BillNo" prop="BillNo" :min-width="WidthControl('BillNo',tableData)" :label="$t('QmAbnQlyOrder.BillNo')">
                    <template scope="scope">
                        <el-link :underline="false" @click="DetailPage(scope.$index, scope.row)">{{ scope.row.BillNo }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column key="FOrgName" prop="FOrgName" v-if="$store.state.ShowComp"  :min-width="WidthControl('FOrgName',tableData)" :label="$t('QmAbnQlyOrder.FOrgId')"></el-table-column>
                <el-table-column key="DangerLv" prop="DangerLv" :min-width="WidthControl('DangerNm',tableData)" :label="$t('QmAbnQlyOrder.DangerLvId')">
                    <template scope="scope">
                        <span :class="`DangerLv${scope.row.DangerLv}`">{{ scope.row.DangerNm }}</span>
                    </template>
                </el-table-column>
                <el-table-column key="DiscoveryDate" prop="DiscoveryDate" :min-width="WidthControl('DiscoveryDate',tableData)" :label="$t('QmAbnQlyOrder.DiscoveryDate')"></el-table-column>
                <el-table-column key="MaterialId" prop="MaterialId" :min-width="WidthControl('MaterialId',tableData)" :label="$t('QmAbnQlyOrder.MaterialId')"></el-table-column>
                <el-table-column key="MaterialName" prop="MaterialName" :min-width="WidthControl('MaterialName',tableData)" :label="$t('QmAbnQlyOrder.MaterialName')"></el-table-column>
                <el-table-column key="MTONo" prop="MTONo" v-if="$store.state.ShowMTO" :min-width="WidthControl('MTONo',tableData)" :label="$t('QmAbnQlyOrder.MTONo')"></el-table-column>
                <el-table-column v-if="$store.state.ShowBatchNo"  key="BatchNo" prop="BatchNo" :min-width="WidthControl('BatchNo',tableData)" :label="$t('QmAbnQlyOrder.BatchNo')"></el-table-column>
                <el-table-column key="SUnitName" :min-width="WidthControl('DefectiveQty&&SUnitName',tableData)" :label="$t('QmAbnQlyOrder.DefectiveQty')">
                    <template slot-scope="scope">
                            <span>{{ scope.row.DefectiveQty }}&nbsp{{ scope.row.SUnitName }}</span>
                        </template>
                </el-table-column>
                <el-table-column key="ReplayDate" prop="ReplayDate" :min-width="WidthControl('ReplayDate',tableData,6)" :label="$t('QmAbnQlyOrder.ReplayDate')"></el-table-column>
                <el-table-column key="ExcpDescribe" prop="ExcpDescribe" width="174" :label="$t('QmAbnQlyOrder.ExcpDescribe')">
                    <template slot-scope="scope">
                        <span class="ExcpDescribe">{{ scope.row.ExcpDescribe }}</span>
                    </template>
                </el-table-column>
                <el-table-column key="BillState" prop="BillState" :min-width="WidthControl('BillState',tableData)" :label="$t('QmAbnQlyOrder.BillState')"></el-table-column>
                <el-table-column key="operation" width="120" :label="$t('Order.operation')">
                    <template slot-scope="scope">
                        <el-button class="topbutton" size="mini" type="text" @click="DetailPage(scope.$index, scope.row)">
                        {{ $t('button.check') }}
                        </el-button>
                        <el-button class="topbutton" size="mini" type="text" @click="DetailPage(scope.$index, scope.row,'edit')">
                        {{ $t('button.modification') }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: center;">
                <PageSizeChanger  :pagesize.sync="pagesize"  :afterChange="pageSizeChange"></PageSizeChanger>
                <el-pagination style="margin:5px 0;padding-top: 4px;" @current-change="handleCurrentChange" :page-size="$store.state.pagesize"
                layout="total,prev,pager,next,jumper" :pager-count="5" :current-page.sync="currentPage" :total="totalCount">
                </el-pagination>
            </div>
        </div>
       </Frame>
</template>
<script>
import { handleShortDate } from '../utils/handleDate.js'
import PageSizeChanger from '@/components/PageSizeChanger.vue'
import {getWebSupplierConfig} from '@/utils/utils'
export default{
    name:'QmAbnQlyOrder',
    components:{PageSizeChanger},
    data(){
        return {
            ProgId:"qmAbnQlyOrder",
            MaterialId:'',
            myDate:'',
            MaterialName:'',
            batchNo:'',
            mtoNo:'',
            Deadly:false,
            Seriousness:false,
            Slight:false,
            TobeConfirmed:true,
            Processing:false,
            finished:false,
            isDisabled:false,
            tableData:[],
            tableLoading:false,
            tableHeight : window.innerHeight - 342,
            totalCount:0,
            currentPage:1,
            pageindex:0,
            pagesize: this.$store.state.pagesize,
            startdate:'',
            enddate:'',
        }
    },
    async mounted(){
        let that = this
        window.onresize = () => {
            if (that.resizeFlag) {
                clearTimeout(that.resizeFlag);
            }
            that.resizeFlag = setTimeout(() => {
                that.tableHeight = window.innerHeight - 342
                that.resizeFlag = null;
            }, 100);
        }
        await getWebSupplierConfig(this);
        if (sessionStorage.getItem("qmAbnQlyOrderDetail") && sessionStorage.getItem("qmAbnQlyOrderDetail") != "null") {
            var history = JSON.parse(sessionStorage.getItem("qmAbnQlyOrderDetail"));
            this.MaterialId = history.MaterialId;
            this.MaterialName = history.MaterialName;
            this.batchNo = history.batchNo;
            this.mtoNo = history.mtoNo;
            this.Deadly = history.Deadly;
            this.Seriousness = history.Seriousness;
            this.Slight = history.Slight;
            this.TobeConfirmed = history.TobeConfirmed;
            this.Processing = history.Processing;
            this.finished = history.finished;
            this.isDisabled = history.isDisabled;
            this.pageindex = history.pageindex;
            this.pagesize = history.pagesize;
            this.startdate = history.startdate;
            this.enddate = history.enddate;
            this.myDate = history.myDate;
            this.getorderdata(history.pageindex);
            sessionStorage.removeItem("qmAbnQlyOrderDetail");
        }else{
            this.getorderdata(0);
        }


   
    },
    methods:{
        inputchange(){
            this.getorderdata(0);
        },
        getorderdata(pageindex){
            this.tableLoading = true;
            this.pageindex = pageindex;
            this.axiosInvoke("/SupplierComm/Handler/VueSysHandler.ashx",
                {
                    action: "getqmabnqlyorder",
                    MaterialId:this.MaterialId,
                    MaterialName:this.MaterialName,
                    batchNo:this.batchNo,
                    mtoNo:this.mtoNo,
                    Deadly:this.Deadly,
                    Seriousness:this.Seriousness,
                    Slight:this.Slight,
                    TobeConfirmed:this.TobeConfirmed,
                    Processing:this.Processing,
                    finished:this.finished,
                    isDisabled:this.isDisabled,
                    pageindex:this.pageindex,
                    pagesize:this.pagesize,
                    startdate:this.startdate,
                    enddate:this.enddate,
                },(res)=>{
                    this.tableLoading = false;
                    var data = res.data;
                    this.totalCount = data[0].totalCount;
                    this.ProgId = data[0].ProgId;
                    data.shift();
                    this.tableData = data;
                    this.currentPage = Number(this.pageindex)+1;
                    this.$nextTick(()=>{   
                        this.$refs.multipleTable.doLayout();
                        })
                    });
        },
        //获取时间
        gettime() {
            if(this.myDate){
                this.startdate = handleShortDate(this.myDate[0], "From");
                this.enddate = handleShortDate(this.myDate[1], "To");
            }
            else{
                this.startdate = "";
                this.enddate = "";
            }
            this.getorderdata(0);
        },
        reset(){
            this.MaterialId='',
            this.myDate='',
            this.startdate="",
            this.enddate="",
            this.MaterialName='',
            this.batchNo='',
            this.mtoNo='',
            this.Seriousness = false;
            this.Slight = false;
            this.Deadly = false;
            this.TobeConfirmed = true;
            this.Processing = false;
            this.finished = false;
            this.getorderdata(0);
        },
        query(){
            this.getorderdata(0);
        },
        handleCurrentChange(val){
            this.pageindex = val - 1;
            this.getorderdata(val - 1);
        },
        setHistory(){
            sessionStorage.setItem("qmAbnQlyOrder", JSON.stringify({
                        MaterialId:this.MaterialId,
                        MaterialName:this.MaterialName,
                        batchNo:this.batchNo,
                        mtoNo:this.mtoNo,
                        Deadly:this.Deadly,
                        Seriousness:this.Seriousness,
                        Slight:this.Slight,
                        TobeConfirmed:this.TobeConfirmed,
                        Processing:this.Processing,
                        finished:this.finished,
                        isDisabled:this.isDisabled,
                        pageindex:this.pageindex,
                        pagesize:this.pagesize,
                        startdate:this.startdate,
                        enddate:this.enddate,
                        myDate:this.myDate,
                    }))
        },
        DetailPage(index,row,edit){
            if(!edit){
                this.setHistory();
                this.$router.push({
                    path: "/Home/QmAbnQlyOrderDetail",
                    query: {
                    BillNo: row.BillNo,
                    edit:edit
                }
            })
            }else{
                this.axiosInvoke("/SupplierComm/Handler/OrderPurPurchaseHandler.ashx", {
                    action:"ispermitedit",
                    ProgId:this.ProgId,
                    BillNo:row.BillNo,
                    },(res,errflag)=>{
                    if(!errflag){
                    this.setHistory();
                    this.$router.push({
                        path: "/Home/QmAbnQlyOrderDetail",
                        query: {
                        BillNo: row.BillNo,
                        edit:edit
                        }
                    })
                    }
                });
            }
         

         
        },
        pageSizeChange(){
            this.getorderdata(0); 
      
        },
    }
}
</script>
<style scoped>
.qmAbnQlyOrder_contain{
    font-size: 14px;
    padding: 10px 0px;
}
.filter_row {
    display: flex;
    justify-content: left;
    flex-wrap: nowrap;
    width: 100%;
    padding: 10px 20px;
}
.filter_col {
    display: flex;
    width: 21%;
    padding-left: 10px;
    padding-right: 10px;
    margin-bottom: 10px;
}
.el-checkbox{
    margin-right: 20px;
}
@media screen  and (max-width: 1500px)  {
    .filter_col{
        width: 19%;
    }
    .buttongroup{
        width: 15%;
    }
    .el-checkbox{
    margin-right: 10px;
}
}
.filter_col span{
    white-space: nowrap;
    margin: auto 0;
}
.checkgroup{
    display: flex;
    flex-wrap: nowrap;
}
.checkgroup span{
    margin: auto 0;
}

.datepicker{
    width: 100%;
    min-width: 215px;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 100%;
}
.buttongroup{
    margin: 0 30px 0 auto;
    justify-content: right;
}
.el-table /deep/ thead {
  font-size: 14px;
  color: #5d5d5d;
}
.el-table /deep/ th.el-table__cell {
  background-color: #f9f9f9;
}
.ExcpDescribe{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.DangerLv0{
    color: #FF3B30 ;
}
.DangerLv1{
    color: #FF9500 ;
}
.DangerLv2{
    color: #007AFF ;
}
</style>
